


























































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { updateIsReadStatus } from '@/appsync/service/AnnouncementMutationService';
import { fetchUserAnnouncements } from '@/appsync/service/AnnouncementQueryService';
import { getIsPortalEnabledStatus } from '@/appsync/service/SystemSettingQueryService';
import AnnouncementLink from '@/components/molecules/AnnouncementLink.vue';
import { CaptionCollection } from '@/components/organisms/PortalAnnouncementsPanel.vue';
import { refreshStores } from '@/containers/globals/globalSharedService';
import PageNotFound from '@/containers/pages/PageNotFound.vue';
import ErrorMessagePageTemplate from '@/containers/templates/ErrorMessagePageTemplate.vue';
import PortalAppBar from '@/containers/templates/PortalAppBar.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { commonModule } from '@/store/modules/CommonStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import {
  UserInfo,
  LoginInfo,
  UserAnnouncement,
  UpdateUserAnnouncementQueryParam,
  PaginationDataType,
} from '@/types/type';
import {
  getDisabledRoutes,
  checkBottomAndFetchData,
} from '@/utils/CommonUtils';
import { PAGE_PATH_BY_NAME } from '@/utils/consts';

@Component({
  components: {
    PortalAppBar,
    ErrorMessagePageTemplate,
    AnnouncementLink,
    PageNotFound,
  },
})
export default class AnnouncementList extends Vue {
  private loading: boolean = true;
  private isAnnouncementEnabled: boolean = false;
  private loginInfo!: LoginInfo;
  private userAnnouncements: UserAnnouncement[] = [];
  private notEnabledImgAltMessage: String = 'Page Not Enabled';
  private notEnabledImgName: String = 'page-not-enabled';
  private notEnabledImgWidth: String = '250px';
  private notEnabledImgHeight: String = '186px';
  private nextToken: string | undefined;
  private ANNOUNCEMENT_COL_HEIGHT: number = 37; //to keep the same height as the default height
  private ANNOUNCEMENT_ID_FIELD = 'id';
  private isPortalEnabled: boolean = true;

  public async created(): Promise<void> {
    const loginInfo: LoginInfo = commonModule.loginInfo;
    this.loginInfo = loginInfo;
    await refreshStores(loginInfo);
    const disabledRoutes = await getDisabledRoutes(
      loginInfo.tenant,
      loginInfo.landscape,
      loginInfo.loginName
    );

    this.isPortalEnabled = await getIsPortalEnabledStatus(
      loginInfo.tenant,
      loginInfo.landscape
    );

    if (!disabledRoutes.includes(PAGE_PATH_BY_NAME.announcementList)) {
      this.isAnnouncementEnabled = true;
      const pageHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      const userAnnouncementRelatedData = await fetchUserAnnouncements(
        this.loginInfo,
        this.nextToken,
        pageHeight / this.ANNOUNCEMENT_COL_HEIGHT
      );
      this.userAnnouncements = userAnnouncementRelatedData.items;
      this.nextToken = userAnnouncementRelatedData.nextToken;
    }
    this.loading = false;
  }

  public async mounted(): Promise<void> {
    this.bindFetchUserAnnouncementOnScrollAndResize();
  }

  public get announcementColCSSVars() {
    return {
      '--height': `${this.ANNOUNCEMENT_COL_HEIGHT}px`,
    };
  }

  private get captionCollection(): CaptionCollection {
    // For link
    const priorityTagHigh: string = i18n.tc('announcement.highPriorityFlg');
    const priorityTagMedium: string = i18n.tc('announcement.mediumPriorityFlg');
    const priorityTagLow: string = i18n.tc('announcement.lowPriorityFlg');

    // For dialog
    const displayPeriodLabel: string = i18n.tc(
      'announcement.displayPeriodLabel'
    );
    const contentLabel: string = i18n.tc('announcement.contentLabel');
    const updateDateLabel: string = i18n.tc('announcement.updateDateLabel');
    const urlLabel: string = i18n.tc('announcement.urlLabel');
    const close: string = i18n.tc('common.close');

    const captionCollection: CaptionCollection = {
      priorityTagHigh,
      priorityTagMedium,
      priorityTagLow,
      displayPeriodLabel,
      contentLabel,
      updateDateLabel,
      urlLabel,
      close,
    };
    return captionCollection;
  }

  private bindFetchUserAnnouncementOnScrollAndResize() {
    window.onscroll = this.checkBottomAndFetchAnnouncementData;
    window.onresize = this.checkBottomAndFetchAnnouncementData;
  }

  private async checkBottomAndFetchAnnouncementData() {
    const fetchedData: PaginationDataType | null = await checkBottomAndFetchData(
      this.userAnnouncements,
      this.ANNOUNCEMENT_ID_FIELD,
      fetchUserAnnouncements,
      this.loginInfo,
      this.nextToken
    );
    if (fetchedData) {
      this.userAnnouncements = fetchedData.items;
      this.nextToken = fetchedData.nextToken;
    }
  }

  private get notEnabledTitleText(): string {
    return i18n.tc('pageNotEnabled.titleText');
  }

  private get notEnabledSubText(): string {
    return i18n.tc('pageNotEnabled.subText');
  }

  private get pageTitle(): string {
    return i18n.tc('portal.announcements');
  }

  private get noAnnouncement(): string {
    return i18n.tc('announcement.noAnnouncement');
  }

  private get userInfo(): UserInfo {
    return loginUserModule.userInfo;
  }

  private async changeIsReadSatus(
    param: UpdateUserAnnouncementQueryParam
  ): Promise<void> {
    if (param) {
      const loginInfo: LoginInfo = commonModule.loginInfo;
      await updateIsReadStatus(
        loginInfo.tenant,
        loginInfo.landscape,
        loginInfo.loginName,
        param.announcementId,
        param.displayStartDate
      );
    }
  }
}
